<template>
    <div id="container" class="container">
      <!-- service -->
      <main class="service" id="contents">
        <!-- top -->
        <div class="top-contents service-top-contents">
          <div class="wrap">
            <div class="service-top-txt">
              <h1 tabindex="0">JUST DIVE!</h1>
              <span class="service-logo">
                <img src="../../assets/images/service/main_logo.png" alt="Wavve 로고">
              </span>
              <span class="cp-p" tabindex="0">KBS, MBC, SBS 등 100개 이상의 채널<br />해외드라마, 애니메이션 포함 방송 VOD 30만편,<br />영화 2만편(추가 결제 없는 월정액 영화 6천편) <br />지금 시작하세요!<br /></span>
            </div>
          </div>
        </div>
        <!--// top -->

        <!-- service 01 -->
        <div class="service-sec01">
          <!-- slider -->
          <div id="swiper-container" class="swiper-container s01-slider">
            <!-- If we need pagination -->
            <div class="swiper-pagination"></div>
            <!-- Additional required wrapper -->
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <img src="../../assets/images/service/service-sec01-img01.png" alt="재미의 파도를 타다! Wavve. 다시 한번 새로워진 Wavve! 더욱 다양한 콘텐츠와 혜택, Wavve에서 재미의 파도를 타 보세요.">
              </div>
              <div class="swiper-slide">
                <img src="../../assets/images/service/service-sec01-img02.png" alt="볼만한 콘텐츠, 더욱 재미있게 만나세요. 오직 웨이브에서만 만나볼 수 있는 다양한 콘텐츠와 테마별 에디터 픽으로 보고싶은 콘텐츠를 만나보세요.">
              </div>
              <div class="swiper-slide">
                <img src="../../assets/images/service/service-sec01-img03.png" alt="더욱 풍부해진 LIVE, VOD, 영화. 지상파 포함 LIVE 채널과 방송 VOD, 취향저격 해외시리즈와 영화! 세상에서 가장 빠른 Quick VOD는 물론, 이용권 하나로 영화까지!">
              </div>
              <div class="swiper-slide">
                <img src="../../assets/images/service/service-sec01-img05.png" alt="더욱 합리적이고 새로워진 Wavve 이용권. Basic, Standard, Premium 어떤 이용권으로든 다양한 기기에서 6,000편의 Wavvie 영화까지 자유롭게!">
              </div>
            </div>
            <!-- swiper button -->
            <div class="s01-slider-btn">
              <div class="swiper-button-prev"></div>
              <div class="swiper-button-next"></div>
            </div>
          </div>
          <!--// slider -->
        </div>
        <!--// service 01 -->

        <!-- service 02 -->
        <div class="service-sec02 tAc">
          <div class="if-wrap">
            <p class="sb-sec02-txt01">Wavve style</p>
            <h2 class="sb-sec02-txt02" tabindex="0">Fit your
              <span class="sb-txt">screen</span>
            </h2>
            <p class="sb-sec02-txt03" tabindex="0">당신의 스크린에 딱 맞추어 Wavve를 즐겨보세요.</p>
            <img src="../../assets/images/service/service-sec02-img01.png" alt="Wavve style, Fit your screen, 당신의 스크린에 딱 맞추어 Wavve를 즐겨보세요. 더 넓게, 더 편리하게">
            <ul class="sb-sec02-list" tabindex="0">
              <li>
                <strong>더 넓게</strong>
                <p>
                  삼성/LG 스마트TV,<br />
                  스마트 프로젝터에 탑재된<br />
                  Wavve를 만나보세요!
                </p>
              </li>
              <li>
                <strong>더 편리하게</strong>
                <p>
                  크롬캐스트, 패밀리허브,<br />
                  android 셋톱박스 등<br />
                  다양한 기기에서 편리하게<br />
                  Wavve를 이용하세요!
                </p>
              </li>
            </ul>
          </div>
        </div>
        <!--// service 02 -->

        <!-- service 02 -->
        <div class="service-sec02 pt60 tAc">
          <div class="if-wrap">
            <p class="sb-sec02-txt01">Wavve Style</p>
            <h2 class="sb-sec02-txt02 tab-contents" tabindex="0">Fit your
              <span class="sb-txt">style</span>
            </h2>
            <p class="sb-sec02-txt03" tabindex="0">당신의 스타일에 맞추어 Wavve를 즐겨보세요!</p>
            <img src="../../assets/images/service/service-sec02-img02.png" alt="Wavve style, Fit your screen, 당신의 스크린에 딱 맞추어 Wavve를 즐겨보세요. 영화도 Wavve! 음악도 Wavve! PC방, 병원, 도서관에서도 무료로!">
            <ul class="sb-sec02-list" tabindex="0">
              <li>
                <img src="../../assets/images/service/service-sec02-img03.png" alt="영화도 Wavve!">
                <strong>영화도 Wavve!</strong>
                <p>
                  Wavve 이용권으로<br />
                  수천편의 Wavvie 영화까지<br />
                  마음껏 즐기세요!
                </p>
              </li>
              <li>
                <img src="../../assets/images/service/service-sec02-img04.png" alt="음악도 Wavve!">
                <strong>음악도 Wavve!</strong>
                <p>
                  방송과 음악을 가장 알뜰하게<br />
                  즐기는 방법!<br />
                  Wavve X Bugs 결합상품!
                </p>
              </li>
              <li>
                <img src="../../assets/images/service/service-sec02-img05.png" alt="PC방, 병원, 도서관에서도 무료로!">
                <strong>PC방, 병원, 도서관에서도<br />무료로!</strong>
                <p>
                  &lt;Wavve on&gt; 가맹점에서는 로그인 없이<br />
                  Wavve를 무료로 즐길 수 있어요!
                </p>
              </li>
            </ul>
          </div>
        </div>
        <!--// service 02 -->

        <!-- service 03 -->
        <div class="service-sec03 tAc">
          <div class="if-wrap">
            <p class="sb-sec03-txt01" tabindex="0">앱 다운로드</p>
            <h2 class="sb-sec03-txt02" tabindex="0">새로운 Wavve를 만나보세요</h2>
            <p class="sb-sec03-txt03">더욱 다양한 콘텐츠와 혜택, Wavve에서 재미의 파도를 타 보세요.</p>
            <img src="../../assets/images/service/service-sec03-img01.png" alt="Wavve 앱 다운로드">
            <ul class="sb-sec03-list" tabindex="0">
              <li>
                <a href="https://itunes.apple.com/kr/app/pug-pooq/id987782077?ls=1&mt=8" target="_blank" rel="noopener noreferrer">
                  <img src="../../assets/images/service/service-sec03-img02.jpg" alt="앱스토어 다운로드">
                </a>
              </li>
              <li>
                <a href="https://play.google.com/store/apps/details?id=kr.co.captv.pooqV2&hl=ko" target="_blank" rel="noopener noreferrer">
                  <img src="../../assets/images/service/service-sec03-img03.jpg" alt="구글스토어 다운로드">
                </a>
              </li>
            </ul>
          </div>
        </div>
        <!--// service 03 -->

        <!-- service 04 -->
        <div class="service-sec04 tAc">
          <div class="if-wrap">
            <p class="sb-sec04-txt01">이용권</p>
            <h2 class="sb-sec04-txt02" tabindex="0">어떤 이용권으로든<br />Wavvie 영화까지 자유롭게!</h2>
            <p class="sb-sec04-txt03" tabindex="0">
              원하는 최고 화질과 동시접속 회선 수에 따라 <br>
              나에게 꼭 맞는 이용권을 선택하세요.
            </p>
            <a href="#" @click.prevent="moveUrl()" class="service-voucher-link">Wavve 이용권 보러가기</a>
          </div>
        </div>
        <!--// service 04 -->

        <!-- service 05 -->
        <div class="service-sec05">
          <div class="sb-sec05-txt" tabindex="0">
            <p>Wavve의 새로운 소식을 누구보다 먼저 받아보고 싶다면?</p>
            <strong>SNS에서 “Wavve”를 팔로우하세요!</strong>
          </div>
          <ul class="sb-sec05-list">
            <li>
              <a href="https://www.facebook.com/Wavve.official/" target="_blank" rel="noopener noreferrer">
                <img src="../../assets/images/service/service-sec04-img01.jpg" alt="Wavve 페이스북">
              </a>
            </li>
            <li>
              <a href="http://m.post.naver.com/my.nhn?memberNo=12375258" target="_blank" rel="noopener noreferrer">
                <img src="../../assets/images/service/service-sec04-img02.jpg" alt="Wavve 네이버 포스트">
              </a>
            </li>
            <li>
              <a href="https://www.youtube.com/c/Wavve" target="_blank" rel="noopener noreferrer">
                <img src="../../assets/images/service/service-sec04-img03.jpg" alt="Wavve 유튜브 채널">
              </a>
            </li>
          </ul>
        </div>
        <!--// service 05 -->
      </main>
      <!--// service -->
    </div>
</template>

<script>
import Swiper from '@/mixins/swiper'
import { PATH_NAME_VOUCHER_INDEX } from '@/common/resources/router.const'
import { titleTagNameChange } from '@/common/utils/common'
export default {
  mixins: [
    Swiper
  ],
  data () {
    return {
      sticky: false,
      swiperOptions: {
        pagination: '.swiper-pagination',
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev'
      }
    }
  },
  methods: {
    moveUrl () {
      this.$router.push({ name: PATH_NAME_VOUCHER_INDEX })
    }
  },
  created () {
    this.$nextTick(() => {
      this.swiperElement = '#swiper-container'
      this.isReady = true
    })
    titleTagNameChange('웨이브 서비스소개')
  }
}
</script>
<style lang="scss" src="@/assets/scss/category/service.scss"></style>
